export default "__VITE_ASSET__CVW2Qjko__"